import styled from 'styled-components'

export const StepSelectProcote = styled.div`
  width: 640px;
  height: 495px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

export const StepSelectProcoteTitle = styled.div`
  font-weight: bold;
  margin-bottom: 40px;
`

export const ButtonsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 186px);
  grid-gap: 17px;

  ${props => props.theme.media.mobile`
    grid-template-columns: repeat(2, 124px);
    grid-gap: 8px;
  `}
`
